import { render, staticRenderFns } from "./WasteDiagnosticPage.vue?vue&type=template&id=1a454363&scoped=true&"
import script from "./WasteDiagnosticPage.vue?vue&type=script&lang=js&"
export * from "./WasteDiagnosticPage.vue?vue&type=script&lang=js&"
import style0 from "./WasteDiagnosticPage.vue?vue&type=style&index=0&id=1a454363&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a454363",
  null
  
)

export default component.exports